/*
 * File: input-textarea.ts
 * File Created: 2024-01-14 04:56:13
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-24 06:56:34
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseInputComponent } from "../core/lib/base-input-component";
import { PropInnateSync } from "@root/core/vue-props";

@Component
export default class InputTextarea extends BaseInputComponent {
    @PropInnateSync("value", { type: String, default: null })
    innateValue!: string | null;
}
